import context from '@truckdown/components-systems';
import { ChangePasswordModel, UserModel, IUserManager } from "@truckdown/accounts";
import { defineComponent, ref, Ref, computed, onMounted } from "vue";
import { isGeneralAdmin, showMessage } from "../../../Utilities/Utilities";
import validationError from "../../../Validation/Error/Error.vue";
import { ChangePasswordValidator } from "../../Validation/ChangePasswordValidator";

interface IChangePasswordForm {
    newPassword: string,
    confirmPassword: string
}

interface IData {
    isLoading: Ref<boolean>,
    changePasswordValidator: Ref<any>,
    model: Ref<ChangePasswordModel>,
    form: Ref<IChangePasswordForm>
};

const getInitialData = function (props: any) {

    var model = {
        id: props.user.id,
        newPassword: ""
    } as ChangePasswordModel;

    var changePasswordForm = {
        newPassword: "",
        confirmPassword: ""
    } as IChangePasswordForm;

    return {
        isLoading: ref<boolean>(false),
        changePasswordValidator: ref<any>(new ChangePasswordValidator(changePasswordForm)),
        model: ref<ChangePasswordModel>(model),
        form: ref<IChangePasswordForm>(changePasswordForm)
    } as IData;
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        changePasswordCancelClick: function (): void {
            ctx.emit(cancelEventName);
        },
        changePasswordSaveClick: async function (): Promise<void> {
            await changePassword(data, props, ctx);
        }
    }
}

const isPasswordValid = function (data: IData): boolean {
    data.changePasswordValidator.value = new ChangePasswordValidator(data.form.value);
    return data.changePasswordValidator.value.validate();
}

const changePassword = async function (data: IData, props: any, ctx: any): Promise<void> {
    if (!data.isLoading.value && isPasswordValid(data)) {
        data.isLoading.value = true;

        data.model.value.newPassword = data.form.value.newPassword;

        try {
            let userManager = await context.getService<IUserManager>('IUserManager');

            var response = await userManager.changePassword(data.model.value);

            if (!response || !response.ok) {
                console.log("Error changing password: " + response.message);
                showMessage("Error changing password.", "danger", true, true);
            } else {
                showMessage("Error changing password.", "success", true, true);
                ctx.emit(updatedEventName, response.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            data.isLoading.value = false;
        }
    }
}

const updatedEventName = 'update';
const cancelEventName = 'cancel';

export default defineComponent({
    props: {
        user: {
            type: Object as () => UserModel,
            required: true
        }
    },
    components: {
        'error': validationError,
    },
    emits: [updatedEventName, cancelEventName],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let methods = getMethods(props, data, ctx);

        return {
            ...data,
            ...computed,
            ...methods,
        };
    }
});